// Constants/EmailValidationTypes.ts
export const EmailValidationTypes = {
    InvalidEmail: 'InvalidEmail',
    Deactivated: 'Deactivated',
    Pending: 'Pending',
    Active: 'Active',
} as const;

export type EmailValidationType = typeof EmailValidationTypes[keyof typeof EmailValidationTypes];
